export default "__VITE_ASSET__RHfirv0d__"